/**
 * CykelmakkerApi
 * CykelmakkerApi
 *
 * The version of the OpenAPI document: v3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type EUserStatus = 'Activated' | 'Deactivated' | 'Deleted';

export const EUserStatus = {
    Activated: 'Activated' as EUserStatus,
    Deactivated: 'Deactivated' as EUserStatus,
    Deleted: 'Deleted' as EUserStatus
};

